const LineGraphDateRangeEnum = Object.freeze({
	DAILY: 'Daily',
	WEEKLY: 'Weekly',
	MONTHLY: 'Monthly',
});

export default LineGraphDateRangeEnum;
